"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ScrollableStack = _interopRequireDefault(require("@commerce-ui/core2/ScrollableStack"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Image = _interopRequireDefault(require("../Image"));
var __jsx = _react["default"].createElement;
var PhotoSlider = function PhotoSlider(props) {
  var slides = props.slides,
    buttonNext = props.buttonNext,
    buttonPrevious = props.buttonPrevious;
  return __jsx(_ScrollableStack["default"], {
    sx: {
      width: "100%",
      maxWidth: "100%",
      color: "white",
      $itemsVisible: [1.3, null, 1, null],
      $gap: 10
    },
    previousButton: function previousButton(_ref) {
      var isAtStart = _ref.isAtStart;
      return {
        button: function button(_ref2) {
          var buttonProps = _ref2.buttonProps;
          return __jsx(_Box["default"], {
            sx: {
              display: isAtStart ? "none" : "block"
            }
          }, /*#__PURE__*/_react["default"].cloneElement(buttonPrevious, buttonProps));
        },
        offset: 20
      };
    },
    nextButton: function nextButton(_ref3) {
      var isAtEnd = _ref3.isAtEnd;
      return {
        button: function button(_ref4) {
          var buttonProps = _ref4.buttonProps;
          return __jsx(_Box["default"], {
            sx: {
              display: isAtEnd ? "none" : "block"
            }
          }, /*#__PURE__*/_react["default"].cloneElement(buttonNext, buttonProps));
        },
        offset: 20
      };
    }
  }, slides.map(function (slide, index) {
    return __jsx(_Image["default"], {
      sx: {
        width: "100%",
        objectFit: "cover",
        aspectRatio: 1.33
      },
      key: index,
      image: slide,
      sizes: "(max-width: 1070px) and (min-width: 10px) 420px, 768px"
    });
  }));
};
var _default = PhotoSlider;
exports["default"] = _default;